import { getClient } from '../getClient'
import { getLocaleRegionIdFromPath } from '@aether/utils'
import { groq } from 'next-sanity'
import { createEventProjection } from '../projections/createEventProjection'
import { createSEOProjection } from '../projections/createSEOProjection'
import { createPageBuilderProjection } from '../projections/createPageBuilderProjection'
import { ROUTE_BASE_EVENTS } from '@aether/configs'
import { EventData } from './getEventsPage'
import { PortableTextBlock, PageLink, PageBuilderSection } from '@aether/models'
import { getIsDateInPDTInPast } from '@aether/utils'

interface Section {
  title: string
  content: PortableTextBlock
}

export interface DetailedEvent extends EventData {
  locationLong?: PortableTextBlock
  locationLink?: PageLink
  descriptionSection?: Section[]
  infoSection?: Section[]
  pageBuilder?: PageBuilderSection[]
}

export const getEventByHandle = async (
  handle: string,
  locale: string,
  preview = false,
): Promise<DetailedEvent | null> => {
  const [, localeId] = getLocaleRegionIdFromPath(locale)
  const EVENT_PROJECTION = createEventProjection(localeId, true)
  const SEO_PROJECTION = createSEOProjection(localeId)
  const PAGE_BUILDER_PROJECTION = createPageBuilderProjection(localeId)

  const path = `${ROUTE_BASE_EVENTS}/${handle}`
  const query = groq`*[_type == "event" && path.current == $path][0]{
    ${EVENT_PROJECTION},
    "seo": seo${SEO_PROJECTION},
    "pageBuilder": pageBuilder[]${PAGE_BUILDER_PROJECTION}
  }`

  const event = await getClient(preview).fetch(query, { path })

  if (!event) {
    return null
  }

  return {
    ...event,
    isEventEnded: getIsDateInPDTInPast(event.endDate || event.startDate),
  }
}
